import { UserRole } from "@ambii-com/core";
import { liteCollections, liteQueryCollectionLimited } from "~/utils/firestoreLite";

export async function readIsClinicAdmin(userId: string): Promise<boolean> {
  const docs = await liteQueryCollectionLimited(
    liteCollections.admins,
    1,
    ["uid", "==", userId]
  );
  if (docs.length === 0) {
    return false;
  }
  return docs[0].data()?.role === UserRole.CLINIC;
}
